module.exports = __webpack_public_path__ + "img/business.432e75a3.png";